export default "__VITE_ASSET__DQR9Obv8__"